import { useState } from "react";
import logo from "../../assets/mundialito.png";

export default function TablaPosiciones() {
  const torneos = [
    {
      titulo: "Sub 6",
      equipos: [
        {
          posicion: 1,
          equipo: "Micezan",
          PJ: 3,
          PG: 3,
          PE: 0,
          PP: 0,
          GF: 24,
          GC: 3,
          DG: "+21",
          PTS: 9,
        },
        {
          posicion: 2,
          equipo: "SBC",
          PJ: 3,
          PG: 2,
          PE: 0,
          PP: 1,
          GF: 12,
          GC: 5,
          DG: "+7",
          PTS: 6,
        },
        {
          posicion: 3,
          equipo: "Atlético Mantense",
          PJ: 3,
          PG: 1,
          PE: 0,
          PP: 2,
          GF: 4,
          GC: 13,
          DG: "−9",
          PTS: 3,
        },
        {
          posicion: 4,
          equipo: "Pablo Saucedo",
          PJ: 3,
          PG: 0,
          PE: 0,
          PP: 3,
          GF: 2,
          GC: 21,
          DG: "−19",
          PTS: 0,
        },
      ],
      goleadores: [
        { nombre: "MIGUEL CEDEÑO MERA", equipo: "MICEZAM", goles: 31 },
        { nombre: "MEDRANDA CEVALLOS JACOB", equipo: "MICEZAM", goles: 17 },
        { nombre: "RAMIREZ ARIANA", equipo: "SBC", goles: 9 },
        { nombre: "RAMIREZ ALCIVAR ARIANA", equipo: "SBC", goles: 3 },
        { nombre: "LOOR CEVALLOS CARLOS", equipo: "PABLO SAUCEDO", goles: 2 },
        { nombre: "NORTHBORN IAM", equipo: "ATLÉTICO MANTENSE", goles: 2 },
        { nombre: "LINO JEAN CARLOS", equipo: "SBC", goles: 2 },
        { nombre: "DELGADO NAEL", equipo: "SBC", goles: 1 },
        { nombre: "PARRALES ALVARADO SANTIAGO", equipo: "SBC", goles: 1 },
        {
          nombre: "ZAMBRANO MERA MATEO",
          equipo: "ATLETICO MANTENSE",
          goles: 1,
        },
        {
          nombre: "ZAMBRANO PORTILLA EMILIANO",
          equipo: "ATLETICO MANTENSE",
          goles: 1,
        },
        { nombre: "VASQUEZ IAN", equipo: "MICEZAM", goles: 1 },
        { nombre: "ZAMBRANO DANTE", equipo: "MICEZAM", goles: 1 },
        { nombre: "MEDRANDA JORGE", equipo: "MICEZAM", goles: 1 },
        { nombre: "MOREIRA ANGEL", equipo: "MICEZAM", goles: 1 },
      ],
    },
    {
      titulo: "Sub 7",
      equipos: [
        {
          posicion: 1,
          equipo: "SBC",
          PJ: 3,
          PG: 3,
          PE: 0,
          PP: 0,
          GF: 20,
          GC: 7,
          DG: "+13",
          PTS: 9,
        },
        {
          posicion: 2,
          equipo: "Micezam",
          PJ: 3,
          PG: 2,
          PE: 0,
          PP: 1,
          GF: 17,
          GC: 7,
          DG: "+10",
          PTS: 6,
        },
        {
          posicion: 3,
          equipo: "Atlético Mantense",
          PJ: 3,
          PG: 1,
          PE: 0,
          PP: 2,
          GF: 13,
          GC: 14,
          DG: "-1",
          PTS: 3,
        },
        {
          posicion: 4,
          equipo: "Más Que Vencedores del Compa",
          PJ: 3,
          PG: 0,
          PE: 0,
          PP: 3,
          GF: 4,
          GC: 26,
          DG: "-22",
          PTS: 0,
        },
      ],
      goleadores: [
        { nombre: "URDANIGO CEVALLOS IKER", equipo: "SBC", goles: 30 },
        { nombre: "MEDRANDA CEVALLOS JACOB", equipo: "MICEZAM", goles: 7 },
        { nombre: "MACIAS LAZ ALAIA", equipo: "MICEZAM", goles: 9 },
        { nombre: "CEDEÑO MERA MIGUEL", equipo: "MICEZAM", goles: 6 },
        { nombre: "MENDOZA MARCELO", equipo: "ATLETICO MANTENSE", goles: 6 },
        { nombre: "BRAVO JUNIOR", equipo: "MQV EL COMPA", goles: 4 },
        {
          nombre: "VERA GANCHOZO DANIEL",
          equipo: "ATLETICO MANTENSE",
          goles: 3,
        },
        { nombre: "ALAVA EKER", equipo: "MQV EL COMPA", goles: 2 },
        { nombre: "SUAREZ LUCIANO", equipo: "ATLETICO MANTENSE", goles: 2 },
        { nombre: "PALMA LIAM", equipo: "SBC", goles: 2 },
        { nombre: "ECHEVERRIA JOFRE", equipo: "ATLETICO MANTENSE", goles: 1 },
        { nombre: "INTRIAGO JORDY", equipo: "ATLETICO MANTENSE", goles: 1 },
        { nombre: "LOPEZ MAIKEL", equipo: "SBC", goles: 1 },
        { nombre: "ALMEIDA HOLGUIN DYLAN", equipo: "MQV EL COMPA", goles: 3 },
        { nombre: "ALMEIDA CEDEÑO VICTOR", equipo: "MQV EL COMPA", goles: 2 },
        {
          nombre: "MENDOZA ESPINOZA WILLIAMS",
          equipo: "MQV EL COMPA",
          goles: 1,
        },
      ],
    },
    {
      titulo: "Sub 8",
      equipos: [
        {
          posicion: 1,
          equipo: "Tohali",
          PJ: 12,
          PG: 11,
          PE: 0,
          PP: 1,
          GF: 51,
          GC: 10,
          DG: "+41",
          PTS: 33,
          color: "lightgreen",
        },
        {
          posicion: 2,
          equipo: "Almac",
          PJ: 12,
          PG: 9,
          PE: 1,
          PP: 2,
          GF: 50,
          GC: 13,
          DG: "+37",
          PTS: 28,
          color: "lightgreen",
        },
        {
          posicion: 3,
          equipo: "SBC",
          PJ: 12,
          PG: 9,
          PE: 1,
          PP: 2,
          GF: 37,
          GC: 11,
          DG: "+26",
          PTS: 28,
          color: "lightgreen",
        },
        {
          posicion: 4,
          equipo: "Leones FC",
          PJ: 12,
          PG: 8,
          PE: 0,
          PP: 4,
          GF: 38,
          GC: 19,
          DG: "+19",
          PTS: 24,
          color: "lightgreen",
        },
        {
          posicion: 5,
          equipo: "Unión",
          PJ: 12,
          PG: 7,
          PE: 1,
          PP: 4,
          GF: 22,
          GC: 22,
          DG: "0",
          PTS: 22,
          color: "lightgreen",
        },
        {
          posicion: 6,
          equipo: "Atletico Mantense",
          PJ: 12,
          PG: 6,
          PE: 2,
          PP: 4,
          GF: 34,
          GC: 24,
          DG: "+10",
          PTS: 20,
          color: "lightgreen",
        },
        {
          posicion: 7,
          equipo: "Independiente SC",
          PJ: 12,
          PG: 5,
          PE: 3,
          PP: 4,
          GF: 22,
          GC: 20,
          DG: "+2",
          PTS: 18,
          color: "lightgreen",
        },
        {
          posicion: 8,
          equipo: "La Pradera",
          PJ: 12,
          PG: 6,
          PE: 0,
          PP: 6,
          GF: 19,
          GC: 22,
          DG: "-3",
          PTS: 18,
          color: "lightgreen",
        },
        {
          posicion: 9,
          equipo: "Micezam",
          PJ: 12,
          PG: 5,
          PE: 1,
          PP: 6,
          GF: 24,
          GC: 21,
          DG: "+3",
          PTS: 16,
          color: "orange",
        },
        {
          posicion: 10,
          equipo: "Pablo Saucedo",
          PJ: 12,
          PG: 4,
          PE: 1,
          PP: 7,
          GF: 19,
          GC: 26,
          DG: "-7",
          PTS: 13,
          color: "orange",
        },
        {
          posicion: 11,
          equipo: "Nueva Esperanza",
          PJ: 12,
          PG: 0,
          PE: 0,
          PP: 12,
          GF: 0,
          GC: 65,
          DG: "-65",
          PTS: 0,
          color: "orange",
        },
        {
          posicion: "",
          equipo: "Barbasquillo",
          PJ: 4,
          PG: 2,
          PE: 0,
          PP: 2,
          GF: 5,
          GC: 6,
          DG: -1,
          PTS: 6,
          status: "eliminado",
          color: "red",
        },
        {
          posicion: "",
          equipo: "Sandino",
          PJ: 4,
          PG: 2,
          PE: 0,
          PP: 2,
          GF: 5,
          GC: 6,
          DG: -1,
          PTS: 6,
          status: "eliminado",
          color: "red",
        },
      ],
      goleadores: [
        { nombre: "MONTALVAN LIAM STEFANO", equipo: "LEONES FC", goles: 26 },
        {
          nombre: "ACOSTA ADORNO MARCO ALESAANDRO",
          equipo: "ATLETICO MANTENSE",
          goles: 17,
        },
        { nombre: "CANTOS CHAVEZ VICTOR", equipo: "ALMAC", goles: 15 },
        { nombre: "ANZULES CHOEZ THIAGO", equipo: "TOHALLÍ", goles: 15 },
        { nombre: "URDANIGO CEVALLOS IKER", equipo: "SBC", goles: 10 },
        { nombre: "CORNEJO MORA GERARD", equipo: "UNIÓN O&P", goles: 10 },
        { nombre: "MACIAS LAZ ALAIA", equipo: "MICEZAM", goles: 8 },
        { nombre: "VELEZ RAMOS DERECK", equipo: "TOHALLÍ", goles: 8 },
        { nombre: "MACIAS CEDEÑO CESAR", equipo: "ALMAC", goles: 8 },
        { nombre: "MACIAS MERWIN", equipo: "ALMAC", goles: 7 },
        { nombre: "DELGADO OCHOA AARON", equipo: "SBC", goles: 7 },
        { nombre: "BURGOS VELEZ JERICK", equipo: "ALMAC", goles: 7 },
        { nombre: "GUERRERO COOX IKER", equipo: "UNIÓN O&P", goles: 7 },
        { nombre: "SANDOVAL HERNANDEZ JORGE", equipo: "TOHALLÍ", goles: 6 },
        { nombre: "MEJIA REZABALA ERICK", equipo: "ALMAC", goles: 6 },
        { nombre: "LOOR CEDEÑO AMIR", equipo: "TOHALLÍ", goles: 6 },
        { nombre: "VALVERDE BAYRON DAMIAN", equipo: "LEONES FC", goles: 5 },
        { nombre: "MONTALVAN LIAM STEFANO", equipo: "LEONES FC", goles: 5 },
        { nombre: "MENDOZA LOOR PATRICK", equipo: "SBC", goles: 5 },
        { nombre: "MERO ZAMBRANO ALLAN", equipo: "MICEZAM", goles: 5 },
        { nombre: "CEDEÑO MERA MIGUEL ANDRES", equipo: "MICEZAM", goles: 4 },
        { nombre: "SORNOZA MENDOZA LIAM", equipo: "PABLO SAUCEDO", goles: 4 },
        {
          nombre: "GRACIA QUIJIJE JOSTIN",
          equipo: "INDEPENDIENTE SC",
          goles: 4,
        },
        { nombre: "QUIROZ LEYTON", equipo: "LA PRADERA", goles: 4 },
        { nombre: "MAZA SALTOS JARED", equipo: "BARBASQUILLO", goles: 4 },
        { nombre: "DELGADO JEILYN", equipo: "LEONES FC", goles: 3 },
        { nombre: "BARCIA DELGADO DYLAN", equipo: "BARBASQUILLO", goles: 3 },
        { nombre: "GONZALEZ MILAN", equipo: "SBC", goles: 3 },
        {
          nombre: "ZAMBRANO MENDOZA LUCAS",
          equipo: "ATLETICO MANTENSE",
          goles: 3,
        },
        { nombre: "CANO LOPEZ GUSTAVO", equipo: "INDEPENDIENTE SC", goles: 3 },
        { nombre: "VELEZ JORGE", equipo: "PABLO SAUCEDO", goles: 3 },
        {
          nombre: "VERA GANCHOZO DANIEL",
          equipo: "ATLETICO MANTENSE",
          goles: 3,
        },
        {
          nombre: "LOOR REYES SEBASTIAN",
          equipo: "ATLETICO MANTENSE",
          goles: 3,
        },
        { nombre: "LAZ VERA ANGEL", equipo: "PABLO SAUCEDO", goles: 3 },
        { nombre: "RODRIGUEZ RIVAS JAMES", equipo: "PABLO SAUCEDO", goles: 3 },
        { nombre: "ORMAZA LOOR JESUS", equipo: "TOHALLÍ", goles: 3 },
        { nombre: "RAMIREZ ALAVA SAMIR", equipo: "INDEPENDIENTE SC", goles: 3 },
        { nombre: "RODRIGUEZ JUNIOR", equipo: "PABLO SAUCEDO", goles: 2 },
        { nombre: "DANILO INTRIAGO", equipo: "BARBASQUILLO", goles: 2 },
        { nombre: "MOREIRA AXEL", equipo: "ALMAC", goles: 2 },
        { nombre: "PARRAGA JEREMY", equipo: "SBC", goles: 2 },
        {
          nombre: "PARRAGA GONZALEZ EMILIANO",
          equipo: "PABLO SAUCEDO",
          goles: 2,
        },
        { nombre: "CORNEJO JORMAN", equipo: "LEONES FC", goles: 2 },
        { nombre: "PARRAGA SOZA AXEL", equipo: "MICEZAM", goles: 2 },
        { nombre: "SANTIANA MERA JONAIKER", equipo: "ALMAC", goles: 2 },
        {
          nombre: "CELLERI ALAVA VICTOR",
          equipo: "INDEPENDIENTE SC",
          goles: 2,
        },
        { nombre: "CASTILLO SUAREZ JOSADAC", equipo: "LA PRADERA", goles: 2 },
        { nombre: "PARRAGA MATUTE JOSE", equipo: "TOHALLÍ", goles: 2 },
        { nombre: "MORA RAFAEL", equipo: "PABLO SAUCEDO", goles: 1 },
        { nombre: "MACIAS ETHAN", equipo: "SBC", goles: 1 },
        { nombre: "MEDRANDA CEVALLOS JACOB", equipo: "MICEZAM", goles: 1 },
        { nombre: "CEDEÑO IAM PAUL", equipo: "INDEPENDIENTE SC", goles: 1 },
        { nombre: "VERA LUIS", equipo: "INDEPENDIENTE SC", goles: 1 },
        { nombre: "ACOSTA JUAN", equipo: "LA PRADERA", goles: 1 },
        { nombre: "AVILA DERECK", equipo: "BARBASQUILLO", goles: 1 },
        {
          nombre: "PALACIOS INTRIAGO AYLAN",
          equipo: "PABLO SAUCEDO",
          goles: 1,
        },
        { nombre: "ALVIA BAQUE DEYKER", equipo: "LA PRADERA", goles: 1 },
        { nombre: "BARROS ZAMBRANO MILTON", equipo: "LA PRADERA", goles: 1 },
        { nombre: "VEGA HIDALGO JOSÉ", equipo: "ATLETICO MANTENSE", goles: 1 },
        { nombre: "ZAMBRANO CARRANZA ROMARIO", equipo: "SBC", goles: 1 },
        { nombre: "MENENDEZ ANCHUNDIA ÁNGEL", equipo: "MICEZAM", goles: 1 },
        { nombre: "CARREÑO MENDOZA EYTHAN", equipo: "MICEZAM", goles: 1 },
        { nombre: "CEVALLOS AVILA DAVID", equipo: "BARBASQUILLO", goles: 1 },
        { nombre: "ASTUDILLO PIZON JOSE", equipo: "SBC", goles: 1 },
        { nombre: "ESPINOZA MANTUANO", equipo: "SBC", goles: 1 },
        { nombre: "MERO VERA BASTIAN", equipo: "INDEPENDIENTE SC", goles: 1 },
        { nombre: "MOLINA MENDOZA", equipo: "INDEPENDIENTE SC", goles: 1 },
        { nombre: "MENDOZA MENDOZA ELIAS", equipo: "UNIÓN O&P", goles: 1 },
      ],
    },
    {
      titulo: "Sub 9",
      equipos: [
        {
          posicion: 1,
          equipo: "Independiente SC",
          PJ: 7,
          PG: 6,
          PE: 0,
          PP: 1,
          GF: 20,
          GC: 7,
          DG: "+13",
          PTS: 18,
          color: "lightgreen",
        },
        {
          posicion: 2,
          equipo: "Pablo Saucedo",
          PJ: 7,
          PG: 5,
          PE: 1,
          PP: 1,
          GF: 22,
          GC: 6,
          DG: "+16",
          PTS: 16,
          color: "lightgreen",
        },
        {
          posicion: 3,
          equipo: "SBC",
          PJ: 7,
          PG: 4,
          PE: 1,
          PP: 2,
          GF: 24,
          GC: 18,
          DG: "+6",
          PTS: 13,
          color: "lightgreen",
        },
        {
          posicion: 4,
          equipo: "Nueva Esperanza",
          PJ: 7,
          PG: 2,
          PE: 3,
          PP: 2,
          GF: 14,
          GC: 19,
          DG: "-5",
          PTS: 9,
          color: "lightgreen",
        },
        {
          posicion: 5,
          equipo: "Barbasquillo",
          PJ: 7,
          PG: 2,
          PE: 2,
          PP: 3,
          GF: 17,
          GC: 16,
          DG: "+1",
          PTS: 8,
          color: "lightgreen",
        },
        {
          posicion: 6,
          equipo: "Unión",
          PJ: 7,
          PG: 2,
          PE: 2,
          PP: 3,
          GF: 10,
          GC: 17,
          DG: "-7",
          PTS: 8,
          color: "lightgreen",
        },
        {
          posicion: 7,
          equipo: "Más Que Vencedores Compa",
          PJ: 7,
          PG: 2,
          PE: 1,
          PP: 4,
          GF: 18,
          GC: 28,
          DG: "-10",
          PTS: 7,
          color: "orange",
        },
        {
          posicion: "",
          equipo: "SANDINO",
          PJ: "",
          PG: "",
          PE: "",
          PP: "",
          GF: "",
          GC: "",
          DG: "",
          PTS: "",
          status: "eliminado",
          color: "red",
        },
      ],
      goleadores: [
        { nombre: "POSLIGUA ESPINOZA IKER ALEXANDER", equipo: "SBC", goles: 8 },
        { nombre: "REYES ADAMS JEREMIAS", equipo: "BARBASQUILLO", goles: 8 },
        { nombre: "MERA MOREIRA ANGEL", equipo: "INDEPENDIENTE SC", goles: 8 },
        {
          nombre: "TELLO VILLAMIL MAXIMILIANO",
          equipo: "INDEPENDIENTE SC",
          goles: 8,
        },
        {
          nombre: "VASQUEZ MACIAS ALDAIR EMILIANO",
          equipo: "PABLO SAUCEDO",
          goles: 6,
        },
        { nombre: "RODRIGUEZ ALBERTO", equipo: "PABLO SAUCEDO", goles: 5 },
        { nombre: "MURILLO MILAN JOHAN", equipo: "PABLO SAUCEDO", goles: 4 },
        { nombre: "BARCIA LIAM URIEL", equipo: "BARBASQUILLO", goles: 4 },
        { nombre: "SALDARRIAGA ZAMBRANO", equipo: "PABLO SAUCEDO", goles: 4 },
        { nombre: "MOLINA MOREIRA LIAN", equipo: "NUEVA ESPERANZA", goles: 3 },
        { nombre: "URETA LUCAS PATRICIO", equipo: "MQV EL COMPA", goles: 3 },
        { nombre: "RAMIREZ BENJAMIN", equipo: "SBC", goles: 3 },
        { nombre: "QUIROZ JESUS DAMIAN", equipo: "SBC", goles: 3 },
        { nombre: "CLARKE MERO ISAIAS", equipo: "INDEPENDIENTE SC", goles: 3 },
        { nombre: "ALTAFUYA LOPEZ AYDEN", equipo: "SBC", goles: 3 },
        { nombre: "PLAZA EITHAN GARDEL", equipo: "SBC", goles: 3 },
        { nombre: "ALAVA TOALA THIAGO", equipo: "INDEPENDIENTE SC", goles: 3 },
        {
          nombre: "RODRIGUEZ ECHEVERRIA JAHIR",
          equipo: "PABLO SAUCEDO",
          goles: 3,
        },
        { nombre: "URDANIGO CEVALLOS IKER", equipo: "SBC", goles: 3 },
        { nombre: "BUSTAMANTE AXEL DYLAN", equipo: "MQV EL COMPA", goles: 3 },
        { nombre: "LOOR ROSADO IAN GAEL", equipo: "MQV EL COMPA", goles: 3 },
        {
          nombre: "INTRIAGO ANCHUNDIA DYLAN",
          equipo: "PABLO SAUCEDO",
          goles: 3,
        },
        { nombre: "MEO MOREIRA ANGEL", equipo: "INDEPENDIENTE SC", goles: 2 },
        { nombre: "LOOR VELASQUEZ ELIAM", equipo: "SBC", goles: 2 },
        {
          nombre: "RODRIGUEZ MIGUEL ANGEL",
          equipo: "NUEVA ESPERANZA",
          goles: 2,
        },
        {
          nombre: "ESPINALES LOOR CRISTHIAN SNEIDER",
          equipo: "NUEVA ESPERANZA",
          goles: 2,
        },
        { nombre: "LARA GARCIA JUAN", equipo: "PABLO SAUCEDO", goles: 2 },
        { nombre: "GUERRERO COOX IKER", equipo: "UNIÓN O&P", goles: 2 },
        { nombre: "RODRIGUEZ JAHIR", equipo: "PABLO SAUCEDO", goles: 2 },
        { nombre: "SORNOZA MENDOZA LIAM", equipo: "PABLO SAUCEDO", goles: 1 },
        { nombre: "LOPEZ IDEN", equipo: "SBC", goles: 1 },
        { nombre: "DELGADO JARED", equipo: "SBC", goles: 1 },
        { nombre: "MERO JORDAN", equipo: "SBC", goles: 1 },
        { nombre: "ALAVA TOALA DYLAN", equipo: "INDEPENDIENTE SC", goles: 1 },
        { nombre: "RAMIREZ ALAVA SAMIR", equipo: "INDEPENDIENTE SC", goles: 1 },
        { nombre: "BERMEO IKER", equipo: "UNIÓN O&P", goles: 1 },
        { nombre: "RAMIREZ GHAEL DAVID", equipo: "BARBASQUILLO", goles: 1 },
        {
          nombre: "PONCE FABRICIO DAMIAN",
          equipo: "NUEVA ESPERANZA",
          goles: 1,
        },
        {
          nombre: "BUSTAMANTE JOSTYN MICHAEL",
          equipo: "MQV EL COMPA",
          goles: 1,
        },
        { nombre: "CHICA DASHA MEY", equipo: "MQV EL COMPA", goles: 1 },
        { nombre: "GILER DYLAN JULIAN", equipo: "BARBASQUILLO", goles: 1 },
        { nombre: "VILLON GABRIEL MOISES", equipo: "BARBASQUILLO", goles: 1 },
        { nombre: "BAILON BRYAN DARKIEL", equipo: "BARBASQUILLO", goles: 1 },
        { nombre: "VEGA ANDRE NEHEMÍAS", equipo: "BARBASQUILLO", goles: 1 },
        { nombre: "CHAVEZ JOSE ANTONIO", equipo: "MQV EL COMPA", goles: 1 },
        { nombre: "JAIMES NOVA JORGE", equipo: "UNIÓN O&P", goles: 1 },
        { nombre: "MORENO OLIVERAS DERECK", equipo: "UNIÓN O&P", goles: 1 },
        {
          nombre: "SALTOS MARTINEZ MATHIAS",
          equipo: "INDEPENDIENTE SC",
          goles: 1,
        },
        { nombre: "MARQUEZ ESPIN SAMUEL", equipo: "UNIÓN O&P", goles: 1 },
        { nombre: "MONTERO VERA THIAGO", equipo: "UNIÓN O&P", goles: 1 },
        { nombre: "GOVEA MERO DERICK", equipo: "BARBASQUILLO", goles: 1 },
        {
          nombre: "MACIAS RODRIGUEZ MARIELA",
          equipo: "INDEPENDIENTE SC",
          goles: 1,
        },
        {
          nombre: "BURGOS PILLIGUA GABRIEL",
          equipo: "INDEPENDIENTE SC",
          goles: 1,
        },
        { nombre: "TUBAY HOLGUIN LUIS MANUEL", equipo: "SBC", goles: 1 },
        { nombre: "BARINA MUENTES LIAM", equipo: "BARBASQUILLO", goles: 1 },
        { nombre: "CEVALLOS REYES THIAGO", equipo: "PABLO SAUCEDO", goles: 1 },
      ],
    },
    {
      titulo: "Sub 10",
      equipos: [
        {
          posicion: 1,
          equipo: "Micezam",
          PJ: 11,
          PG: 8,
          PE: 1,
          PP: 2,
          GF: 51,
          GC: 16,
          DG: "+35",
          PTS: 25,
          color: "lightgreen",
        },
        {
          posicion: 2,
          equipo: "Independiente SC",
          PJ: 11,
          PG: 7,
          PE: 1,
          PP: 3,
          GF: 20,
          GC: 12,
          DG: "+8",
          PTS: 22,
          color: "lightgreen",
        },
        {
          posicion: 3,
          equipo: "Tohalli",
          PJ: 11,
          PG: 6,
          PE: 3,
          PP: 2,
          GF: 19,
          GC: 8,
          DG: "+11",
          PTS: 21,
          color: "lightgreen",
        },
        {
          posicion: 4,
          equipo: "Almac",
          PJ: 11,
          PG: 6,
          PE: 3,
          PP: 2,
          GF: 21,
          GC: 12,
          DG: "+9",
          PTS: 21,
          color: "lightgreen",
        },
        {
          posicion: 5,
          equipo: "Pablo Saucedo",
          PJ: 11,
          PG: 6,
          PE: 2,
          PP: 3,
          GF: 27,
          GC: 11,
          DG: "+16",
          PTS: 20,
          color: "lightgreen",
        },
        {
          posicion: 6,
          equipo: "Atletico Mantense",
          PJ: 11,
          PG: 5,
          PE: 3,
          PP: 3,
          GF: 30,
          GC: 14,
          DG: "+16",
          PTS: 18,
          color: "lightgreen",
        },
        {
          posicion: 7,
          equipo: "La Unión FC",
          PJ: 11,
          PG: 5,
          PE: 2,
          PP: 4,
          GF: 19,
          GC: 21,
          DG: "-2",
          PTS: 17,
          color: "lightgreen",
        },
        {
          posicion: 8,
          equipo: "Leones FC",
          PJ: 11,
          PG: 4,
          PE: 1,
          PP: 6,
          GF: 21,
          GC: 30,
          DG: "-9",
          PTS: 13,
          color: "lightgreen",
        },
        {
          posicion: 9,
          equipo: "La Pradera",
          PJ: 11,
          PG: 2,
          PE: 3,
          PP: 6,
          GF: 17,
          GC: 19,
          DG: "-2",
          PTS: 9,
          color: "orange",
        },
        {
          posicion: 10,
          equipo: "La Gallada JR",
          PJ: 11,
          PG: 3,
          PE: 0,
          PP: 8,
          GF: 12,
          GC: 50,
          DG: "-38",
          PTS: 9,
          color: "orange",
        },
        {
          posicion: "",
          equipo: "IDV Manta",
          PJ: 11,
          PG: 0,
          PE: 1,
          PP: 10,
          GF: 1,
          GC: 33,
          DG: "-32",
          PTS: 1,
          status: "eliminado",
          color: "red",
        },
        {
          posicion: "",
          equipo: "Sandino",
          PJ: 5,
          PG: 4,
          PE: 0,
          PP: 1,
          GF: 11,
          GC: 5,
          DG: "+6",
          PTS: 12,
          status: "eliminado",
          color: "red",
        },
      ],
      goleadores: [
        { nombre: "BURGOS SABANDO ALINA", equipo: "MICEZAM", goles: 22 },
        { nombre: "MONTOYA ROJAS LIAM", equipo: "PABLO SAUCEDO", goles: 8 },
        {
          nombre: "MOREIRA PEÑAHERRERA ANDRE",
          equipo: "ATLETICO MANTENSE",
          goles: 8,
        },
        { nombre: "SANTANA ANDRADE KEILER", equipo: "MICEZAM", goles: 8 },
        {
          nombre: "TELLO VILLAMIL MAXIMILIANO",
          equipo: "INDEPENDIENTE SC",
          goles: 7,
        },
        { nombre: "PALMA CASTRO ALEXIS", equipo: "MICEZAM", goles: 6 },
        {
          nombre: "SUAREZ JOSE EMILIANO",
          equipo: "ATLETICO MANTENSE",
          goles: 6,
        },
        { nombre: "GILER BARCIA RENATO", equipo: "PABLO SAUCEDO", goles: 5 },
        { nombre: "VILLACIS OCHOA AARON", equipo: "LA UNION O&P", goles: 5 },
        { nombre: "ALVIA VITE DANTE", equipo: "PABLO SAUCEDO", goles: 5 },
        { nombre: "ZAMBRANO THIAGO PAUL", equipo: "LEONES FC", goles: 4 },
        { nombre: "SALTOS MATHÍAS NICOLAS", equipo: "ALMAC", goles: 4 },
        { nombre: "CEDEÑO PALACIOS MÍA", equipo: "ALMAC", goles: 4 },
        { nombre: "YOUSSEF INTRIAGO ISAIAS", equipo: "LEONES FC", goles: 4 },
        { nombre: "PINARGOTE LEYTON ISAAC", equipo: "ALMAC", goles: 4 },
        { nombre: "POVEDA VALAREZO ANDRES JARED", equipo: "TOHALLÍ", goles: 4 },
        { nombre: "ANDRADE VILLAFUERTE LUIS", equipo: "LA PRADERA", goles: 4 },
        { nombre: "BERNARDI MERA MATHIAS", equipo: "MICEZAM", goles: 4 },
        {
          nombre: "MACIAS JARA BRAYDEN",
          equipo: "ATLETICO MANTENSE",
          goles: 3,
        },
        {
          nombre: "ACOSTA MARCO ANTONIO",
          equipo: "ATLETICO MANTENSE",
          goles: 3,
        },
        { nombre: "MACIAS DIEGO", equipo: "ATLETICO MANTENSE", goles: 3 },
        { nombre: "BAQUE SANCHEZ JEAN PIERRE", equipo: "ALMAC", goles: 3 },
        { nombre: "MOREIRA ZAMBRANO JEFFERSON", equipo: "MICEZAM", goles: 3 },
        { nombre: "MERA MOREIRA ANGEL", equipo: "INDEPENDIENTE SC", goles: 3 },
        {
          nombre: "ZORRILLA EIMAR GADIEL",
          equipo: "ATLETICO MANTENSE",
          goles: 3,
        },
        { nombre: "AYALA ALEX JOSUE", equipo: "UNIÓN O&P", goles: 3 },
        {
          nombre: "ZAMBRANO JABONERO ROGER",
          equipo: "PABLO SAUCEDO",
          goles: 3,
        },
        { nombre: "GOMEZ KEVIN", equipo: "PABLO SAUCEDO", goles: 2 },
        { nombre: "ROJAS LYAN", equipo: "PABLO SAUCEDO", goles: 2 },
        { nombre: "ZAMBRANO ROGER", equipo: "PABLO SAUCEDO", goles: 2 },
        {
          nombre: "ACOSTA MARCO ALESSANDRO",
          equipo: "ATLETICO MANTENSE",
          goles: 2,
        },
        { nombre: "CEVALLOS JEAN", equipo: "LEONES FC", goles: 2 },
        { nombre: "ZAMBRANO EMILIANO", equipo: "LEONES FC", goles: 2 },
        { nombre: "BONILLA BARRE JULIAN", equipo: "LA PRADERA", goles: 2 },
        { nombre: "BETANCOURT MARTIN", equipo: "LA PRADERA", goles: 2 },
        { nombre: "VERA BARREIRO CARLOS", equipo: "LA GALLADA", goles: 2 },
        { nombre: "BERMNARDI MATHIAS", equipo: "MICEZAM", goles: 2 },
        { nombre: "PALMA LEINER", equipo: "LEONES FC", goles: 2 },
        { nombre: "DUARTE AVEIGA FRANCESA", equipo: "TOHALLÍ", goles: 2 },
        { nombre: "MONTALVAN LIAM STEFANO", equipo: "LEONES FC", goles: 2 },
        { nombre: "LOPEZ THIAGO DEYKER", equipo: "TOHALLÍ", goles: 2 },
        { nombre: "ALAVA TOALA THIAGO", equipo: "INDEPENDIENTE SC", goles: 2 },
        { nombre: "OLEAS SALVADOR CARLOS", equipo: "PABLO SAUCEDO", goles: 2 },
        { nombre: "QUIROZ OSUNA JACOBO", equipo: "UNIÓN O&P", goles: 2 },
        { nombre: "ESTRADA PATA ANDER", equipo: "LA GALLADA", goles: 1 },
        { nombre: "ALVIS PEREZ DILAN", equipo: "MICEZAM", goles: 1 },
        { nombre: "MENDOZA ZAMBRANO MATIAS", equipo: "LA PRADERA", goles: 1 },
        { nombre: "PICO EDU", equipo: "MICEZAM", goles: 1 },
        { nombre: "RAFAEL PEREZ MACÍAS", equipo: "UNIÓN O&P", goles: 1 },
        { nombre: "NEIKER MATHIAS", equipo: "LEONES FC", goles: 1 },
        { nombre: "MERA ROMARIO", equipo: "LEONES FC", goles: 1 },
        { nombre: "SANDOVAL BAILON MISAEL", equipo: "LA GALLADA", goles: 1 },
        { nombre: "LOPEZ THIAGO", equipo: "TOHALLÍ", goles: 1 },
        { nombre: "VINUEZA MILLER", equipo: "ALMAC", goles: 1 },
        { nombre: "GRACIA JOSTIN", equipo: "INDEPENDIENTE SC", goles: 1 },
        { nombre: "PACHAY SANTIAGO", equipo: "LA PRADERA", goles: 1 },
        {
          nombre: "MENDOZA GONZALO NICOLAS",
          equipo: "ATLETICO MANTENSE",
          goles: 1,
        },
        { nombre: "CEDEÑO EMILIANO ONUR", equipo: "PABLO SAUCEDO", goles: 1 },
        { nombre: "SANCHEZ THIAGO WLADIMIR", equipo: "TOHALLÍ", goles: 1 },
        { nombre: "JAIMES NOVA JORGE", equipo: "UNIÓN O&P", goles: 1 },
        {
          nombre: "MENDOZA ZAMORA GONZALO",
          equipo: "ATLETICO MANTENSE",
          goles: 1,
        },
        { nombre: "MALDONADO ZAMBRANO", equipo: "LA PRADERA", goles: 1 },
        { nombre: "CARRANZA TUBAY DERIAN", equipo: "ALMAC", goles: 1 },
        { nombre: "CLARKE MERO ISAIAS", equipo: "INDEPENDIENTE SC", goles: 1 },
        {
          nombre: "OLEAS MIRANDA MATHIAS ALEXANDER",
          equipo: "INDEPENDIENTE SC",
          goles: 1,
        },
        { nombre: "DONATO SANCHEZ", equipo: "INDEPENDIENTE SC", goles: 1 },
        { nombre: "MACIAS GARCIA DYLAN", equipo: "MICEZAM", goles: 1 },
        { nombre: "BALON PONCE IAN", equipo: "LA GALLADA", goles: 1 },
        { nombre: "ALCIVAR ESPINALES DARLYN", equipo: "UNION O&P", goles: 1 },
        { nombre: "CALDERON INTRIAGO THIAGO", equipo: "LA PRADERA", goles: 1 },
        { nombre: "ZAMBRANO TIGSE ELIAN", equipo: "TOHALLÍ", goles: 1 },
        { nombre: "MEJÍA RESABALA JOSÉ", equipo: "ALMAC", goles: 1 },
      ],
    },
    {
      titulo: "Sub 11",
      equipos: [
        {
          posicion: 1,
          equipo: "Más Que Vencedores del Compa",
          PJ: 11,
          PG: 8,
          PE: 2,
          PP: 1,
          GF: 47,
          GC: 15,
          DG: "+32",
          PTS: 26,
          color: "lightgreen",
        },
        {
          posicion: 2,
          equipo: "Pablo Saucedo",
          PJ: 11,
          PG: 7,
          PE: 3,
          PP: 1,
          GF: 39,
          GC: 20,
          DG: "+19",
          PTS: 24,
          color: "lightgreen",
        },
        {
          posicion: 3,
          equipo: "Tohalli",
          PJ: 11,
          PG: 6,
          PE: 3,
          PP: 2,
          GF: 29,
          GC: 19,
          DG: "+10",
          PTS: 21,
          color: "lightgreen",
        },
        {
          posicion: 4,
          equipo: "Independiente SC",
          PJ: 11,
          PG: 6,
          PE: 2,
          PP: 3,
          GF: 28,
          GC: 16,
          DG: "+12",
          PTS: 20,
          color: "lightgreen",
        },
        {
          posicion: 5,
          equipo: "Leones",
          PJ: 11,
          PG: 5,
          PE: 2,
          PP: 4,
          GF: 19,
          GC: 12,
          DG: "+7",
          PTS: 17,
          color: "lightgreen",
        },
        {
          posicion: 6,
          equipo: "La Unión FC",
          PJ: 11,
          PG: 4,
          PE: 3,
          PP: 4,
          GF: 25,
          GC: 18,
          DG: "+7",
          PTS: 15,
          color: "lightgreen",
        },
        {
          posicion: 7,
          equipo: "Barbasquillo",
          PJ: 11,
          PG: 4,
          PE: 3,
          PP: 4,
          GF: 26,
          GC: 34,
          DG: "-8",
          PTS: 15,
          color: "lightgreen",
        },
        {
          posicion: 8,
          equipo: "La Pradera",
          PJ: 11,
          PG: 3,
          PE: 3,
          PP: 5,
          GF: 15,
          GC: 26,
          DG: "-11",
          PTS: 12,
          color: "lightgreen",
        },
        {
          posicion: 9,
          equipo: "Nueva Esperanza",
          PJ: 11,
          PG: 3,
          PE: 3,
          PP: 5,
          GF: 11,
          GC: 23,
          DG: "-12",
          PTS: 12,
          color: "orange",
        },
        {
          posicion: 10,
          equipo: "Atletico Mantense",
          PJ: 11,
          PG: 3,
          PE: 0,
          PP: 8,
          GF: 16,
          GC: 33,
          DG: "-17",
          PTS: 9,
          color: "orange",
        },
        {
          posicion: "",
          equipo: "Atletas de Cristo",
          PJ: 11,
          PG: 2,
          PE: 0,
          PP: 9,
          GF: 10,
          GC: 25,
          DG: "-15",
          PTS: 6,
          status: "eliminado",
          color: "red",
        },
        {
          posicion: "",
          equipo: "Sandino",
          PJ: 11,
          PG: 1,
          PE: 2,
          PP: 8,
          GF: 8,
          GC: 29,
          DG: "-21",
          PTS: 5,
          status: "eliminado",
          color: "red",
        },
      ],
      goleadores: [
        {
          nombre: "CEDEÑO REYES AXEL ELIAS",
          equipo: "MQV EL COMPA",
          goles: 11,
        },
        {
          nombre: "VERA NAPA CARLOS MATHEO",
          equipo: "MQV EL COMPA",
          goles: 11,
        },
        {
          nombre: "CEDEÑO TEJENA JAIRO ADIL",
          equipo: "PABLO SAUCEDO",
          goles: 9,
        },
        { nombre: "MEZA REYES JOSUE", equipo: "PABLO SAUCEDO", goles: 8 },
        {
          nombre: "BERMELLE MONTENEGRO BRYAN",
          equipo: "INDEPENDIENTE SC",
          goles: 7,
        },
        {
          nombre: "CEVALLOS QUIÑONEZ IKER ISMAEL",
          equipo: "UNIÓN O&P",
          goles: 7,
        },
        { nombre: "MERA SOLIS YUREN ALESANDRO", equipo: "UNIÓN O&P", goles: 7 },
        { nombre: "CEVALLOS REYES DIEGO", equipo: "BARBASQUILLO", goles: 6 },
        { nombre: "CATAGUA DELGADO ALBERTO", equipo: "LA PRADERA", goles: 6 },
        { nombre: "ACOSTA CEDEÑO HORACIO", equipo: "MQV EL COMPA", goles: 5 },
        { nombre: "MONTOYA ROJAS LIAM", equipo: "PABLO SAUCEDO", goles: 4 },
        { nombre: "FRANCO B JOSUE DANIEL", equipo: "TOHALLÍ", goles: 4 },
        { nombre: "GARCIA CAÑARTE SEBASTIAN", equipo: "LEONES FC", goles: 4 },
        { nombre: "ALMEIDA ESPINOZA TAYLOR", equipo: "MQV EL COMPA", goles: 4 },
        { nombre: "CEDEÑO RAMOS THIAGO", equipo: "MQV EL COMPA", goles: 4 },
        { nombre: "CEDEÑO TORRES THIAGO", equipo: "MQV EL COMPA", goles: 3 },
        { nombre: "INTRIAGO JANDRY MATHIAS", equipo: "MQV EL COMPA", goles: 3 },
        { nombre: "MENDOZA STEPHANO", equipo: "ATLETICO MANTENSE", goles: 3 },
        { nombre: "ALVAREZ MILAN", equipo: "NUEVA ESPERANZA", goles: 3 },
        { nombre: "CANTOS ALAVA ROGER", equipo: "PABLO SAUCEDO", goles: 3 },
        {
          nombre: "ZAMBRANO JOBONERO ROGER",
          equipo: "PABLO SAUCEDO",
          goles: 3,
        },
        { nombre: "GUTIERREZ LUIS ANGEL", equipo: "BARBASQUILLO", goles: 3 },
        { nombre: "MOLINA C LIAM PAUL", equipo: "PABLO SAUCEDO", goles: 3 },
        { nombre: "MENDOZA ANDRÉS", equipo: "MQV EL COMPA", goles: 3 },
        {
          nombre: "JARAMILLO ANDRÉ GEORGE",
          equipo: "INDEPENDIENTE SC",
          goles: 3,
        },
        { nombre: "ZAMBRANO ANDRES", equipo: "ATLETICO MANTENSE", goles: 3 },
        { nombre: "BARBERAN PILLASAGUA ERICK", equipo: "LEONES FC", goles: 3 },
        { nombre: "HERMIDA JAMA REYNALDO", equipo: "TOHALLÍ", goles: 3 },
        { nombre: "GOVEA MERO DERICK", equipo: "BARBASQUILLO", goles: 3 },
        {
          nombre: "TELLO VILLAMIL CASSIEL",
          equipo: "INDEPENDIENTE SC",
          goles: 2,
        },
        { nombre: "MONTOYA ROJAS LIAM", equipo: "PABLO SAUCEDO", goles: 2 },
        { nombre: "MORALES MARCELO", equipo: "INDEPENDIENTE SC", goles: 2 },
        {
          nombre: "BARBERAN ERICK FRANKLIN",
          equipo: "ATLETICO MANTENSE",
          goles: 2,
        },
        { nombre: "LUZARDO SALTOS IKER", equipo: "INDEPENDIENTE SC", goles: 2 },
        { nombre: "MERA MERA MATHIAS", equipo: "LEONES FC", goles: 2 },
        {
          nombre: "OLEAS MIRANDA MATHIAS ALEXANDER",
          equipo: "INDEPENDIENTE SC",
          goles: 2,
        },
        { nombre: "VILLACIS OCHOA AARON", equipo: "LA UNION O&P", goles: 2 },
        { nombre: "MOLINA GUADAMUD ROBERT", equipo: "TOHALLÍ", goles: 2 },
        { nombre: "PERDOMO MONTES JOSE", equipo: "LEONES FC", goles: 2 },
        { nombre: "MERA CEDEÑO DYLAN", equipo: "TOHALLÍ", goles: 2 },
        {
          nombre: "MACIAS JARA BRAYDEN",
          equipo: "ATLETICO MANTENSE",
          goles: 1,
        },
        { nombre: "VILLAROEL JAVIER", equipo: "INDEPENDIENTE SC", goles: 1 },
        { nombre: "PINARGOTE JIMMY", equipo: "TOHALLÍ", goles: 1 },
        { nombre: "MENDEZ DANILO", equipo: "ATLETICO MANTENSE", goles: 1 },
        { nombre: "CORDERO GARY", equipo: "ATLETICO MANTENSE", goles: 1 },
        { nombre: "SORNOZA TEO", equipo: "NUEVA ESPERANZA", goles: 1 },
        { nombre: "ERICK", equipo: "NUEVA ESPERANZA", goles: 1 },
        { nombre: "SANTANA RUIZ JEREMY", equipo: "MQV EL COMPA", goles: 1 },
        { nombre: "ZAMBRANO CRIS", equipo: "ATLETICO MANTENSE", goles: 1 },
        { nombre: "NEREA MIGUEL", equipo: "BARBASQUILLO", goles: 1 },
        { nombre: "REYES SAMUEL", equipo: "BARBASQUILLO", goles: 1 },
        { nombre: "FRANCO BERNAR", equipo: "BARBASQUILLO", goles: 1 },
        { nombre: "PINTO ERICK", equipo: "NUEVA ESPERANZA", goles: 1 },
        { nombre: "ARTEAGA ANCHUNDIA JACKSON", equipo: "LA PRADERA", goles: 1 },
        { nombre: "GARCIA ARTEAGA FRANKLIN", equipo: "LEONES FC", goles: 1 },
        { nombre: "HOLGUIN KEYLER", equipo: "INDEPENDIENTE SC", goles: 1 },
        { nombre: "VERA DIDIER MATEO", equipo: "NUEVA ESPERANZA", goles: 1 },
        {
          nombre: "TELLO VILLAMIL MAXIMILIANO",
          equipo: "INDEPENDIENTE SC",
          goles: 1,
        },
        {
          nombre: "GUAÑA ISMAEL NICOLAS",
          equipo: "ATLETICO MANTENSE",
          goles: 1,
        },
        {
          nombre: "SALTOS SNAYDER XAVIER",
          equipo: "NUEVA ESPERANZA",
          goles: 1,
        },
        { nombre: "ANDRADE VILLAFUERTE LUIS", equipo: "LA PRADERA", goles: 1 },
        { nombre: "CUSME MERO THIAGO", equipo: "TOHALLÍ", goles: 1 },
        { nombre: "ESPINOZA BORRERO THIAGO", equipo: "TOHALLÍ", goles: 1 },
        { nombre: "MACIAS BRIONES DRAKE", equipo: "LEONES FC", goles: 1 },
        { nombre: "HUERTA ALVAREZ", equipo: "UNIÓN O&P", goles: 1 },
        { nombre: "ALCIVAR CHAVEZ JUAN", equipo: "BARBASQUILLO", goles: 1 },
        { nombre: "VILLON BARCIA", equipo: "BARBASQUILLO", goles: 1 },
        { nombre: "MOLINA CEDEÑO RONALDO", equipo: "UNIÓN O&P", goles: 1 },
      ],
    },
    {
      titulo: "Sub 12",
      equipos: [
        {
          posicion: 1,
          equipo: "Pablo Saucedo",
          PJ: 7,
          PG: 6,
          PE: 1,
          PP: 0,
          GF: 17,
          GC: 1,
          DG: "+16",
          PTS: 19,
          color: "blue",
        },
        {
          posicion: 2,
          equipo: "Tohali",
          PJ: 7,
          PG: 6,
          PE: 0,
          PP: 1,
          GF: 23,
          GC: 3,
          DG: "+20",
          PTS: 18,
          color: "lightgreen",
        },
        {
          posicion: 3,
          equipo: "Independiente SC",
          PJ: 7,
          PG: 3,
          PE: 3,
          PP: 1,
          GF: 14,
          GC: 10,
          DG: "+4",
          PTS: 12,
          color: "lightgreen",
        },
        {
          posicion: 4,
          equipo: "Leones",
          PJ: 7,
          PG: 3,
          PE: 2,
          PP: 2,
          GF: 15,
          GC: 7,
          DG: "+8",
          PTS: 11,
          color: "lightgreen",
        },
        {
          posicion: 5,
          equipo: "La Unión",
          PJ: 7,
          PG: 2,
          PE: 1,
          PP: 4,
          GF: 9,
          GC: 23,
          DG: "-14",
          PTS: 7,
          color: "lightgreen",
        },
        {
          posicion: "",
          equipo: "Gallada JR",
          PJ: 7,
          PG: 2,
          PE: 1,
          PP: 4,
          GF: 12,
          GC: 23,
          DG: "-11",
          PTS: 7,
          status: "eliminado",
          color: "red",
        },
        {
          posicion: "",
          equipo: "Atlético de Cristo",
          PJ: 7,
          PG: 1,
          PE: 0,
          PP: 6,
          GF: 10,
          GC: 18,
          DG: "-8",
          PTS: 3,
          status: "eliminado",
          color: "red",
        },
        {
          posicion: "",
          equipo: "Sandino",
          PJ: 7,
          PG: 0,
          PE: 0,
          PP: 7,
          GF: 0,
          GC: 21,
          DG: "-21",
          PTS: 0,
          status: "eliminado",
          color: "red",
        },
      ],
      goleadores: [
        { nombre: "SOLARTE ORTIZ ANGEL", equipo: "LA GALLADA", goles: 5 },
        { nombre: "ALVIA VITE JEAN CARLOS", equipo: "TOHALLÍ", goles: 4 },
        { nombre: "PINARGOTE FAULA SAMUEL", equipo: "TOHALLÍ", goles: 4 },
        { nombre: "PICO MIRANDA SANTIAGO", equipo: "LEONES FC", goles: 4 },
        {
          nombre: "GUERRERO VASQUEZ MAYKEL",
          equipo: "PABLO SAUCEDO",
          goles: 4,
        },
        { nombre: "HERMIDA JAMA REYNALDO", equipo: "TOHALLÍ", goles: 3 },
        { nombre: "ANDRADE PONCE SAMUEL", equipo: "TOHALLÍ", goles: 2 },
        {
          nombre: "CORAL ZAMBRANO JEREMIAS",
          equipo: "PABLO SAUCEDO",
          goles: 2,
        },
        {
          nombre: "TAPIA MALDONADO BYRON",
          equipo: "INDEPENDIENTE SC",
          goles: 2,
        },
        { nombre: "PERDOMO MONTES JOSE", equipo: "LEONES FC", goles: 2 },
        { nombre: "OZAETA ALBER", equipo: "LA GALLADA", goles: 2 },
        { nombre: "SALDARRIAGA ZAMBRANO", equipo: "PABLO SAUCEDO", goles: 2 },
        { nombre: "MERA SOLIS YUREN", equipo: "UNION O&P", goles: 2 },
        { nombre: "MOLINA GUADAMUD ROBERT", equipo: "TOHALLÍ", goles: 1 },
        { nombre: "PALACIOS CEDEÑO", equipo: "INDEPENDIENTE SC", goles: 1 },
        { nombre: "SALA SOTOMAYOR JOHAN", equipo: "LA GALLADA", goles: 1 },
        { nombre: "GODOY BAQUE EDISON", equipo: "INDEPENDIENTE SC", goles: 1 },
        { nombre: "PARRAGA BRAVO SAMAI", equipo: "INDEPENDIENTE SC", goles: 1 },
        { nombre: "VERA ZAMBRANO DERLIS", equipo: "LEONES FC", goles: 1 },
        { nombre: "VILLEGAS FRANCISCO", equipo: "LEONES FC", goles: 1 },
        { nombre: "PINCAY BYRON", equipo: "LEONES FC", goles: 1 },
        { nombre: "ZAMBRANO CRISTOFER", equipo: "TOHALLÍ", goles: 1 },
        { nombre: "SANTOS JAHIR", equipo: "TOHALLÍ", goles: 1 },
        { nombre: "GARCIA CAÑARTE JOHAN", equipo: "TOHALLÍ", goles: 1 },
        { nombre: "FRANCO BENALCAZAR JOSUE", equipo: "TOHALLÍ", goles: 1 },
        { nombre: "CASTRO ALLAN", equipo: "LA GALLADA", goles: 1 },
        { nombre: "BARBERAN PILLASAGUA ERICK", equipo: "LEONES FC", goles: 1 },
        { nombre: "LUZARDO SALTOS IKER", equipo: "INDEPENDIENTE SC", goles: 1 },
        {
          nombre: "JARAMILLO MACIAS ANDRÉ GEORGE",
          equipo: "INDEPENDIENTE SC",
          goles: 1,
        },
        { nombre: "MENOSCAL SALAS OSTIN", equipo: "PABLO SAUCEDO", goles: 1 },
        { nombre: "MONTOYA ROJAS LIAM", equipo: "PABLO SAUCEDO", goles: 1 },
        { nombre: "JAMES VARGAS ANGEL", equipo: "TOHALLÍ", goles: 1 },
        { nombre: "ZAMBRANO ELIAN", equipo: "TOHALLÍ", goles: 1 },
      ],
    },
    {
      titulo: "Sub 13",
      equipos: [
        {
          posicion: 1,
          equipo: "Pablo Saucedo",
          PJ: 7,
          PG: 6,
          PE: 0,
          PP: 1,
          GF: 29,
          GC: 5,
          DG: "+24",
          PTS: 18,
          color: "blue",
        },
        {
          posicion: 2,
          equipo: "Gallada JR",
          PJ: 7,
          PG: 4,
          PE: 1,
          PP: 2,
          GF: 18,
          GC: 12,
          DG: "+6",
          PTS: 13,
          color: "lightgreen",
        },
        {
          posicion: 3,
          equipo: "Tohalli",
          PJ: 7,
          PG: 4,
          PE: 1,
          PP: 2,
          GF: 10,
          GC: 7,
          DG: "+3",
          PTS: 13,
          color: "lightgreen",
        },
        {
          posicion: 4,
          equipo: "Independiente SC",
          PJ: 7,
          PG: 3,
          PE: 1,
          PP: 3,
          GF: 8,
          GC: 15,
          DG: "-7",
          PTS: 10,
          color: "lightgreen",
        },
        {
          posicion: 5,
          equipo: "La Unión",
          PJ: 7,
          PG: 3,
          PE: 0,
          PP: 4,
          GF: 10,
          GC: 11,
          DG: "-1",
          PTS: 9,
          color: "lightgreen",
        },
        {
          posicion: 6,
          equipo: "Atletico Mantense",
          PJ: 7,
          PG: 3,
          PE: 0,
          PP: 4,
          GF: 12,
          GC: 10,
          DG: "+2",
          PTS: 9,
          color: "lightgreen",
        },
        {
          posicion: 7,
          equipo: "Nueva Esperanza",
          PJ: 7,
          PG: 0,
          PE: 1,
          PP: 6,
          GF: 6,
          GC: 46,
          DG: "-40",
          PTS: 1,
          color: "lightgreen",
        },
        {
          posicion: "",
          equipo: "Sandino",
          PJ: 7,
          PG: 1,
          PE: 0,
          PP: 6,
          GF: 9,
          GC: 18,
          DG: "-9",
          PTS: 3,
          status: "eliminado",
          color: "red",
        },
      ],
      goleadores: [
        { nombre: "SANCHEZ ALCIVAR ADAN", equipo: "PABLO SAUCEDO", goles: 9 },
        { nombre: "BERNARDI MERA DYLAN", equipo: "LA GALLADA", goles: 7 },
        { nombre: "RAMOS REYES GEOFREY", equipo: "PABLO SAUCEDO", goles: 7 },
        { nombre: "PALMA MERA LUIS", equipo: "INDEPENDIENTE SC", goles: 4 },
        { nombre: "VINCES TOALA JOHAN", equipo: "NUEVA ESPERANZA", goles: 3 },
        { nombre: "MENOSCAL SALAS OSTIN", equipo: "PABLO SAUCEDO", goles: 3 },
        { nombre: "ALAVA ZAMBRANO LEANDRO", equipo: "PABLO SAUCEDO", goles: 3 },
        { nombre: "ACEBO MORA DONATO", equipo: "PABLO SAUCEDO", goles: 3 },
        { nombre: "ORTEGA LUIS", equipo: "ATLETICO MANTENSE", goles: 3 },
        { nombre: "ALMEIDA CORRAL JUAN", equipo: "PABLO SAUCEDO", goles: 2 },
        { nombre: "PONCE ZAMBRANO PEDRO", equipo: "LA GALLADA", goles: 2 },
        { nombre: "MOROCHO JOSEPH", equipo: "LA GALLADA", goles: 2 },
        {
          nombre: "ORTEGA CEDEÑO DANIEL",
          equipo: "INDEPENDIENTE SC",
          goles: 1,
        },
        { nombre: "LOOR DELGADO KEVIN", equipo: "TOHALLÍ", goles: 1 },
        {
          nombre: "ARTEAGA MOLINA LUIS",
          equipo: "ATLETICO MANTENSE",
          goles: 1,
        },
        {
          nombre: "PONCE CAMACHO SALVATORE",
          equipo: "ATLETICO MANTENSE",
          goles: 1,
        },
        { nombre: "CASTRO MERO MATTEWS", equipo: "TOHALLÍ", goles: 1 },
        { nombre: "MOREIRA TEJENA JOSUE", equipo: "LA GALLADA", goles: 1 },
        { nombre: "CEDEÑO ALAVA ELQUIS", equipo: "NUEVA ESPERANZA", goles: 1 },
        { nombre: "CEDEÑO JAHIR", equipo: "LA GALLADA", goles: 1 },
        { nombre: "CORAL JESUS", equipo: "ATLETICO MANTENSE", goles: 1 },
        { nombre: "HOPPE CORRAL WALTER", equipo: "PABLO SAUCEDO", goles: 1 },
        { nombre: "ROMERO ALAN JOAO", equipo: "LA GALLADA", goles: 1 },
        { nombre: "PALACIOS ERICK", equipo: "NUEVA ESPERANZA", goles: 1 },
        { nombre: "MARQUEZ THIAGO", equipo: "ATLETICO MANTENSE", goles: 1 },
        { nombre: "FRANCO ADRIAN", equipo: "ATLETICO MANTENSE", goles: 1 },
        { nombre: "CEDEÑO ANGEL", equipo: "ATLETICO MANTENSE", goles: 1 },
        { nombre: "PONCE SALVATORE", equipo: "ATLETICO MANTENSE", goles: 1 },
        { nombre: "CEDEÑO DEIVIS", equipo: "PABLO SAUCEDO", goles: 1 },
        { nombre: "SOLAR ANGEL", equipo: "LA GALLADA", goles: 1 },
        { nombre: "LOPEZ LOPEZ JOSIAS", equipo: "INDEPENDIENTE SC", goles: 1 },
        { nombre: "ALARCON MOREIRA HERNANDO", equipo: "UNION O&P", goles: 1 },
        { nombre: "MEJIA CEVALLOS DIEGO", equipo: "TOHALLÍ", goles: 1 },
        { nombre: "JEAN CARLOS JAVIER", equipo: "TOHALLÍ", goles: 1 },
        { nombre: "SANTOS RODRIGUEZ JOSE", equipo: "PABLO SAUCEDO", goles: 1 },
        { nombre: "LOOR CATAGUA ALFREDO", equipo: "NUEVA ESPERANZA", goles: 1 },
        {
          nombre: "BARBERAN MERO EDUARDO",
          equipo: "NUEVA ESPERANZA",
          goles: 1,
        },
      ],
    },
    {
      titulo: "Sub 14",
      equipos: [
        {
          posicion: 1,
          equipo: "La Unión A",
          PJ: 8,
          PG: 8,
          PE: 0,
          PP: 0,
          GF: 16,
          GC: 0,
          DG: "+16",
          PTS: 24,
          color: "lightgreen",
        },
        {
          posicion: 2,
          equipo: "Independiente SC",
          PJ: 8,
          PG: 6,
          PE: 2,
          PP: 0,
          GF: 19,
          GC: 7,
          DG: "+12",
          PTS: 18,
          color: "lightgreen",
        },
        {
          posicion: 3,
          equipo: "Barbasquillo",
          PJ: 8,
          PG: 5,
          PE: 3,
          PP: 0,
          GF: 14,
          GC: 13,
          DG: "+1",
          PTS: 15,
          color: "lightgreen",
        },
        {
          posicion: 4,
          equipo: "Atletico Mantense",
          PJ: 8,
          PG: 4,
          PE: 3,
          PP: 1,
          GF: 14,
          GC: 7,
          DG: "+7",
          PTS: 13,
          color: "lightgreen",
        },
        {
          posicion: 5,
          equipo: "Gallada JR",
          PJ: 8,
          PG: 4,
          PE: 3,
          PP: 1,
          GF: 14,
          GC: 8,
          DG: "+6",
          PTS: 13,
          color: "lightgreen",
        },
        {
          posicion: 6,
          equipo: "La Unión B",
          PJ: 8,
          PG: 4,
          PE: 0,
          PP: 4,
          GF: 11,
          GC: 10,
          DG: "+1",
          PTS: 12,
          color: "lightgreen",
        },
        {
          posicion: "",
          equipo: "Sandino",
          PJ: 8,
          PG: 2,
          PE: 1,
          PP: 5,
          GF: 9,
          GC: 14,
          DG: -5,
          PTS: 7,
          status: "eliminado",
          color: "red",
        },
        {
          posicion: "",
          equipo: "IDV Manta",
          PJ: 8,
          PG: 0,
          PE: 0,
          PP: 8,
          GF: 0,
          GC: 24,
          DG: -24,
          PTS: 0,
          status: "eliminado",
          color: "red",
        },
        {
          posicion: "",
          equipo: "Leones",
          PJ: 0,
          PG: 0,
          PE: 0,
          PP: 0,
          GF: 0,
          GC: 0,
          DG: 0,
          PTS: 0,
          status: "eliminado",
          color: "red",
        },
      ],
      goleadores: [
        { nombre: "CANDELA JESUS", equipo: "ATLETICO MANTENSE", goles: 4 },
        { nombre: "MOREIRA JAKE", equipo: "LA GALLADA", goles: 3 },
        { nombre: "LUCAS VALBUENA JHON", equipo: "BARBASQUILLO", goles: 3 },
        { nombre: "ZAMBRANO LOPEZ ANGEL", equipo: "UNION O&P A", goles: 3 },
        { nombre: "ORELLANA AXEL LEONEL", equipo: "BARBASQUILLO", goles: 3 },
        {
          nombre: "RODRIGUEZ ALVAREZ JESUS",
          equipo: "INDEPENDIENTE SC",
          goles: 2,
        },
        { nombre: "VERA MONSERRATE JARED", equipo: "LA GALLADA", goles: 2 },
        { nombre: "SANCHEZ EDWARD", equipo: "INDEPENDIENTE SC", goles: 2 },
        { nombre: "LOPEZ GARCIA MAYKEL", equipo: "INDEPENDIENTE SC", goles: 1 },
        { nombre: "PICO MOREIRA JEREMY", equipo: "INDEPENDIENTE SC", goles: 1 },
        { nombre: "MACIAS DELGADO ARIEL", equipo: "LA GALLADA", goles: 1 },
        {
          nombre: "PALACIOS SANTANA JOHN",
          equipo: "ATLETICO MANTENSE",
          goles: 1,
        },
        { nombre: "PATIÑO JORGE", equipo: "INDEPENDIENTE SC", goles: 1 },
        { nombre: "LOPEZ JOSIAS", equipo: "INDEPENDIENTE SC", goles: 1 },
        { nombre: "VELEZ PATRICIO", equipo: "BARBASQUILLO", goles: 1 },
        { nombre: "MENDOZA MARIANO", equipo: "ATLETICO MANTENSE", goles: 1 },
        { nombre: "ALAVA ZAMBRANO DERECK", equipo: "UNION O&P A", goles: 1 },
        { nombre: "ALARCON MOREIRA ARMANDO", equipo: "UNION O&P B", goles: 1 },
        {
          nombre: "INTRIAGO QUIÑONEZ MATHIAS",
          equipo: "ATLETICO MANTENSE",
          goles: 1,
        },
        { nombre: "QUIROZ OSUNA JOSE", equipo: "UNION O&P A", goles: 1 },
        {
          nombre: "SALAZAR GARCIA DOMENICK",
          equipo: "INDEPENDIENTE SC",
          goles: 1,
        },
        {
          nombre: "PONCE CAMACHO SALVATORE",
          equipo: "ATLETICO MANTENSE",
          goles: 1,
        },
        { nombre: "GOYAT CASTRO", equipo: "ATLETICO MANTENSE", goles: 1 },
        { nombre: "LOPEZ SALGADO IRVIN", equipo: "UNION O&P B", goles: 1 },
        { nombre: "LUCAS LOOR THIAGO", equipo: "UNION O&P B", goles: 1 },
        { nombre: "CANTOS BRAVO SNAYDER", equipo: "UNION O&P B", goles: 1 },
        { nombre: "RODRIGUEZ DELGADO CESAR", equipo: "LA GALLADA", goles: 1 },
        { nombre: "AVILA BURGOS JEYDER", equipo: "LA GALLADA", goles: 1 },
        { nombre: "LOPEZ COBOS CESAR", equipo: "LA GALLADA", goles: 1 },
      ],
    },
    {
      titulo: "Sub 15",
      equipos: [
        {
          posicion: 1,
          equipo: "Atletico Mantense",
          PJ: 7,
          PG: 6,
          PE: 0,
          PP: 1,
          GF: 19,
          GC: 3,
          DG: "+16",
          PTS: 18,
          color: "blue",
        },
        {
          posicion: 2,
          equipo: "Unión A",
          PJ: 7,
          PG: 5,
          PE: 2,
          PP: 0,
          GF: 16,
          GC: 2,
          DG: "+14",
          PTS: 17,
          color: "lightgreen",
        },
        {
          posicion: 3,
          equipo: "Independiente SC",
          PJ: 7,
          PG: 3,
          PE: 3,
          PP: 1,
          GF: 8,
          GC: 3,
          DG: "+5",
          PTS: 12,
          color: "lightgreen",
        },
        {
          posicion: 4,
          equipo: "La Unión B",
          PJ: 7,
          PG: 3,
          PE: 1,
          PP: 3,
          GF: 6,
          GC: 5,
          DG: "+1",
          PTS: 10,
          color: "lightgreen",
        },
        {
          posicion: 5,
          equipo: "Tohalli",
          PJ: 7,
          PG: 2,
          PE: 4,
          PP: 1,
          GF: 8,
          GC: 9,
          DG: "-1",
          PTS: 10,
          color: "lightgreen",
        },
        {
          posicion: 6,
          equipo: "Pablo Saucedo",
          PJ: 7,
          PG: 2,
          PE: 1,
          PP: 4,
          GF: 8,
          GC: 11,
          DG: "-3",
          PTS: 7,
          color: "lightgreen",
        },
        {
          posicion: 7,
          equipo: "Nueva Esperanza",
          PJ: 7,
          PG: 1,
          PE: 1,
          PP: 5,
          GF: 6,
          GC: 17,
          DG: "-11",
          PTS: 4,
          color: "lightgreen",
        },
        {
          posicion: 8,
          equipo: "Sandino",
          PJ: 7,
          PG: 0,
          PE: 0,
          PP: 7,
          GF: 0,
          GC: 21,
          DG: -21,
          PTS: 0,
          status: "eliminado",
          color: "red",
        },
      ],
      goleadores: [
        {
          nombre: "MERO QUIÑONEZ GASTER",
          equipo: "ATLETICO MANTENSE",
          goles: 5,
        },
        { nombre: "MEZA JEFREY", equipo: "UNION O&P A", goles: 5 },
        { nombre: "MACIAS JARA JAYDEN", equipo: "ATLETICO MANTENSE", goles: 3 },
        { nombre: "REZABALA HENRRY", equipo: "UNION O&P A", goles: 3 },
        {
          nombre: "DELGADO ZAMBRANO ANGEL",
          equipo: "ATLETICO MANTENSE",
          goles: 3,
        },
        { nombre: "CEDEÑO ARTEAGA JIMMY", equipo: "PABLO SAUCEDO", goles: 2 },
        { nombre: "HONORES ELKIN", equipo: "TOHALLÍ", goles: 2 },
        {
          nombre: "VASQUEZ ALONZO DIDIER",
          equipo: "ATLETICO MANTENSE",
          goles: 1,
        },
        {
          nombre: "ZAMBRANO ALCIVAR JAVIER",
          equipo: "ATLETICO MANTENSE",
          goles: 1,
        },
        { nombre: "PICO JOHAN JOSE", equipo: "NUEVA ESPERANZA", goles: 1 },
        { nombre: "ARROYO BENJAMIN", equipo: "INDEPENDIENTE SC", goles: 1 },
        { nombre: "MOREIRA QUEZADA", equipo: "INDEPENDIENTE SC", goles: 1 },
        { nombre: "PAEZ JOSE", equipo: "INDEPENDIENTE SC", goles: 1 },
        { nombre: "NAVARRETE DIDDIER", equipo: "NUEVA ESPERANZA", goles: 1 },
        { nombre: "RODRIGUEZ GEIKER", equipo: "UNION O&P A", goles: 1 },
        { nombre: "ESPIN THIAGO", equipo: "UNION O&P A", goles: 1 },
        { nombre: "LOPEZ IRVIN", equipo: "UNION O&P B", goles: 1 },
        { nombre: "QUIROZ JOSE", equipo: "UNION O&P B", goles: 1 },
        { nombre: "PEREZ LUIS", equipo: "NUEVA ESPERANZA", goles: 1 },
        { nombre: "SANCHEZ MERO EDISON", equipo: "UNION O&P B", goles: 1 },
        { nombre: "LOPEZ DELGADO", equipo: "PABLO SAUCEDO", goles: 1 },
        { nombre: "VERA DIAZ FRANKLIN", equipo: "TOHALLÍ", goles: 1 },
        { nombre: "AVILA LOOR MAURICIO", equipo: "TOHALLÍ", goles: 1 },
        {
          nombre: "LOPEZ MONDAVI SAMIR",
          equipo: "ATLETICO MANTENSE",
          goles: 1,
        },
        {
          nombre: "GARCIA CAJAS SEBASTIAN",
          equipo: "ATLETICO MANTENSE",
          goles: 1,
        },
        {
          nombre: "VINCES FALCONEZ LEANDRO",
          equipo: "INDEPENDIENTE SC",
          goles: 1,
        },
        {
          nombre: "SANCHEZ ZAMBRANO EDWAR",
          equipo: "INDEPENDIENTE SC",
          goles: 1,
        },
        { nombre: "REYES PILLIGUA DYLAN", equipo: "PABLO SAUCEDO", goles: 1 },
        { nombre: "OTO DELGADO ERICK", equipo: "TOHALLÍ", goles: 1 },
      ],
    },
    {
      titulo: "Sub 16",
      equipos: [
        {
          posicion: 1,
          equipo: "Tohalli",
          PJ: 8,
          PG: 7,
          PE: 1,
          PP: 0,
          GF: 22,
          GC: 2,
          DG: "+20",
          PTS: 22,
          color: "blue",
        },
        {
          posicion: 2,
          equipo: "Atletico Mantense",
          PJ: 8,
          PG: 6,
          PE: 1,
          PP: 1,
          GF: 12,
          GC: 2,
          DG: "+10",
          PTS: 19,
          color: "lightgreen",
        },
        {
          posicion: 3,
          equipo: "La Pradera",
          PJ: 8,
          PG: 5,
          PE: 1,
          PP: 2,
          GF: 12,
          GC: 6,
          DG: "+6",
          PTS: 16,
          color: "lightgreen",
        },
        {
          posicion: 4,
          equipo: "La Unión A",
          PJ: 8,
          PG: 4,
          PE: 0,
          PP: 4,
          GF: 12,
          GC: 11,
          DG: "+1",
          PTS: 12,
          color: "lightgreen",
        },
        {
          posicion: 5,
          equipo: "La Unión B",
          PJ: 8,
          PG: 3,
          PE: 2,
          PP: 3,
          GF: 11,
          GC: 12,
          DG: "-1",
          PTS: 11,
          color: "lightgreen",
        },
        {
          posicion: 6,
          equipo: "La Gallada Jr",
          PJ: 8,
          PG: 3,
          PE: 2,
          PP: 3,
          GF: 7,
          GC: 10,
          DG: "-3",
          PTS: 11,
          color: "lightgreen",
        },
        {
          posicion: 7,
          equipo: "Pablo Saucedo",
          PJ: 8,
          PG: 2,
          PE: 2,
          PP: 4,
          GF: 10,
          GC: 8,
          DG: "+2",
          PTS: 8,
          color: "lightgreen",
        },
        {
          posicion: "",
          equipo: "Leones",
          PJ: 8,
          PG: 1,
          PE: 2,
          PP: 5,
          GF: 3,
          GC: 15,
          DG: -12,
          PTS: 5,
          status: "eliminado",
          color: "red",
        },
        {
          posicion: "",
          equipo: "Sandino",
          PJ: 8,
          PG: 0,
          PE: 1,
          PP: 7,
          GF: 0,
          GC: 21,
          DG: -21,
          PTS: 1,
          status: "eliminado",
          color: "red",
        },
      ],
      goleadores: [
        { nombre: "LOPEZ BRAVO JHONNY", equipo: "TOHALLÍ", goles: 5 },
        { nombre: "ALCIVAR CEVALLOS RONIE", equipo: "PABLO SAUCEDO", goles: 3 },
        { nombre: "CHAVEZ LOPEZ YEIBER", equipo: "UNION O&P A", goles: 3 },
        { nombre: "LOPEZ JHONNY", equipo: "TOHALLÍ", goles: 2 },
        { nombre: "ZAMBRANO PICO MAIKEL", equipo: "LA GALLADA", goles: 2 },
        { nombre: "CEDEÑO CATAGUA JONAYKER", equipo: "TOHALLÍ", goles: 2 },
        {
          nombre: "GUERRERO VASQUEZ MARLON",
          equipo: "PABLO SAUCEDO",
          goles: 2,
        },
        {
          nombre: "PALADINES SABANDO THIAGO",
          equipo: "ATLETICO MANTENSE",
          goles: 2,
        },
        { nombre: "CHOEZ GUADAMUD", equipo: "TOHALLÍ", goles: 2 },
        {
          nombre: "GARCIA CAJAS SEBASTIAN",
          equipo: "ATLETICO MANTENSE",
          goles: 2,
        },
        { nombre: "REZABALA CEDEÑO HENRRY", equipo: "UNION O&P A", goles: 2 },
        { nombre: "ZAMBRANO ANGULO ALAN", equipo: "LA PRADERA", goles: 2 },
        { nombre: "QUIÑOZ LENIN", equipo: "TOHALLÍ", goles: 1 },
        { nombre: "CHIRIBOGA ELIAN", equipo: "TOHALLÍ", goles: 1 },
        { nombre: "CALDERON LOPEZ DENNIS", equipo: "UNION O&P A", goles: 1 },
        { nombre: "LUCAS CONFORME JEFFREY", equipo: "UNION O&P A", goles: 1 },
        { nombre: "MENDOZA MENDOZA KLEYNER", equipo: "UNION O&P B", goles: 1 },
        { nombre: "CEDEÑO MAJOJO MAYKEL", equipo: "LA PRADERA", goles: 1 },
        { nombre: "RODRIGUEZ LOOR OLIVER", equipo: "LA PRADERA", goles: 1 },
        { nombre: "CEDEÑO HUERTA MAYKEL", equipo: "UNION O&P B", goles: 1 },
        { nombre: "CASTRO ANCHUNDIA CESAR", equipo: "TOHALLÍ", goles: 1 },
        { nombre: "QUIROZ ZAMBRANO LENIN", equipo: "TOHALLÍ", goles: 1 },
        { nombre: "CAMPIÑO HURTADO TOMAS", equipo: "PABLO SAUCEDO", goles: 1 },
        { nombre: "CEDEÑO PIN MATEO", equipo: "ATLETICO MANTENSE", goles: 1 },
        { nombre: "ZAMBRANO JAVIER", equipo: "ATLETICO MANTENSE", goles: 1 },
        { nombre: "GARCIA THIAGO", equipo: "ATLETICO MANTENSE", goles: 1 },
        { nombre: "ZAMBRANO CRISTHIAN", equipo: "PABLO SAUCEDO", goles: 1 },
        {
          nombre: "RIVERA RAMIREZ JOSE",
          equipo: "ATLETICO MANTENSE",
          goles: 1,
        },
        { nombre: "PARRALES PAZMIÑO ERICK", equipo: "TOHALLÍ", goles: 1 },
        { nombre: "MERA CEDEÑO ANDRES", equipo: "UNION O&P B", goles: 1 },
        { nombre: "LOOR INTRIAGO KENNEDY", equipo: "LA PRADERA", goles: 1 },
        { nombre: "PICO VERA ZAHIT", equipo: "UNION O&P A", goles: 1 },
        { nombre: "VERA ANCHUNDIA JAYDEN", equipo: "UNION O&P B", goles: 1 },
        { nombre: "VIVAS GOMEZ JORDAN", equipo: "UNION O&P B", goles: 1 },
        { nombre: "MEZA MEZA DARWIN", equipo: "LA PRADERA", goles: 1 },
      ],
    },
    {
      titulo: "Sub 17",
      equipos: [
        {
          posicion: 1,
          equipo: "Unión A",
          PJ: 4,
          PG: 3,
          PP: 1,
          PE: 0,
          GF: 6,
          GC: 1,
          DG: "+5",
          PTS: 10,
          color: "lightgreen",
        },
        {
          posicion: 2,
          equipo: "Tohalli",
          PJ: 4,
          PG: 2,
          PP: 1,
          PE: 1,
          GF: 3,
          GC: 1,
          DG: "+2",
          PTS: 7,
          color: "lightgreen",
        },
        {
          posicion: 3,
          equipo: "Atlético Mantense",
          PJ: 4,
          PG: 1,
          PP: 1,
          PE: 2,
          GF: 2,
          GC: 5,
          DG: "−3",
          PTS: 4,
          color: "lightgreen",
        },
        {
          posicion: 4,
          equipo: "Unión B",
          PJ: 4,
          PG: 1,
          PP: 0,
          PE: 3,
          GF: 4,
          GC: 5,
          DG: "−1",
          PTS: 3,
          color: "lightgreen",
        },
        {
          posicion: 5,
          equipo: "La Pradera",
          PJ: 4,
          PG: 0,
          PP: 3,
          PE: 1,
          GF: 1,
          GC: 4,
          DG: "−3",
          PTS: 2,
          color: "orange",
        },
      ],
      goleadores: [
        { nombre: "MERA FRANCO DAREN", equipo: "UNION O&P B", goles: 3 },
        { nombre: "ALMEIDA BARRETO BRYAN", equipo: "TOHALLÍ", goles: 2 },
        { nombre: "DURAN COLMENZAREZ SANTIAGO", equipo: "TOHALLÍ", goles: 2 },
        { nombre: "MORENO OLEAS JOSE", equipo: "ATLETICO MANTENSE", goles: 2 },
        {
          nombre: "MOREIRA MERA JEFREY",
          equipo: "ATLETICO MANTENSE",
          goles: 1,
        },
        { nombre: "QUIJIJE PICO ALEXANDER", equipo: "LA PRADERA", goles: 1 },
        { nombre: "BAILON DARWIN", equipo: "UNION O&P A", goles: 1 },
        { nombre: "MERO JULIEIBER", equipo: "UNION O&P A", goles: 1 },
        { nombre: "MERO PACHAY ROSEMBERY", equipo: "UNION O&P B", goles: 1 },
        { nombre: "VILLACIS SUSAPANTA JUREN", equipo: "UNION O&P A", goles: 1 },
        { nombre: "CASTRO ROCA EDDY", equipo: "UNION O&P A", goles: 1 },
        { nombre: "VERGARA JUAN DAVID", equipo: "UNION O&P A", goles: 1 },
        {
          nombre: "ZAMBRANO ALCIVAR JAVIER",
          equipo: "ATLETICO MANTENSE",
          goles: 1,
        },
        { nombre: "MURILLO SOLORZANO ANGEL", equipo: "TOHALLÍ", goles: 1 },
        { nombre: "POSLIGUA MACIAS CESAR", equipo: "UNION O&P A", goles: 1 },
        { nombre: "MERA CEDEÑO ANDRES", equipo: "UNION O&P A", goles: 1 },
        { nombre: "GARCIA QUIROZ DERLY", equipo: "UNION O&P A", goles: 1 },
        {
          nombre: "GARCIA CAJAS SEBASTIAN",
          equipo: "ATLETICO MANTENSE",
          goles: 1,
        },
        {
          nombre: "VASQUEZ ALONZO FRANKLIN",
          equipo: "ATLETICO MANTENSE",
          goles: 1,
        },
        { nombre: "PEREZ MOREIRA JOEL", equipo: "UNION O&P A", goles: 1 },
      ],
    },
    {
      titulo: "Sub 18",
      equipos: [
        {
          posicion: 1,
          equipo: "Real Fortaleza",
          PJ: 5,
          PG: 4,
          PE: 1,
          PP: 0,
          GF: 9,
          GC: 1,
          DG: "+8",
          PTS: 13,
          color: "lightgreen",
        },
        {
          posicion: 2,
          equipo: "Tohalli",
          PJ: 5,
          PG: 4,
          PE: 0,
          PP: 1,
          GF: 10,
          GC: 3,
          DG: "+7",
          PTS: 12,
          color: "lightgreen",
        },
        {
          posicion: 3,
          equipo: "La Pradera",
          PJ: 5,
          PG: 2,
          PE: 1,
          PP: 2,
          GF: 6,
          GC: 7,
          DG: "−1",
          PTS: 7,
          color: "lightgreen",
        },
        {
          posicion: 4,
          equipo: "La Unión",
          PJ: 5,
          PG: 2,
          PE: 0,
          PP: 3,
          GF: 10,
          GC: 4,
          DG: "+6",
          PTS: 6,
          color: "lightgreen",
        },
        {
          posicion: "",
          equipo: "Leones",
          PJ: 5,
          PG: 2,
          PE: 0,
          PP: 3,
          GF: 4,
          GC: 9,
          DG: -5,
          PTS: 6,
          status: "eliminado",
        },
        {
          posicion: "",
          equipo: "IDV Manta",
          PJ: 5,
          PG: 0,
          PE: 0,
          PP: 5,
          GF: 0,
          GC: 15,
          DG: -15,
          PTS: 0,
          status: "eliminado",
        },
      ],
      goleadores: [
        { nombre: "VERGARA JUAN DAVID", equipo: "UNION O&P", goles: 3 },
        { nombre: "MACHUCA USCOCOVICH", equipo: "TOHALLÍ", goles: 2 },
        { nombre: "MERA FRANCO DAREN", equipo: "UNION O&P", goles: 1 },
        { nombre: "DURAN COLMENZAREZ SANTIAGO", equipo: "TOHALLÍ", goles: 1 },
        { nombre: "PINCAY ALEXANDER", equipo: "REAL FORTALEZA", goles: 1 },
        { nombre: "SALAZAR FARID", equipo: "REAL FORTALEZA", goles: 1 },
        { nombre: "MURILLO SOLORZANO ANGEL", equipo: "TOHALLÍ", goles: 1 },
        { nombre: "CHUMO MENDEZ GERSON", equipo: "REAL FORTALEZA", goles: 1 },
        { nombre: "BAILON CARREÑO DARWIN", equipo: "UNION O&P", goles: 1 },
        { nombre: "POVEDA TOALA RANDY", equipo: "UNION O&P", goles: 1 },
        { nombre: "FREIRE CEVALLOS KEVIN", equipo: "UNION O&P", goles: 1 },
        { nombre: "JARA TOLEDO JOSE", equipo: "REAL FORTALEZA", goles: 1 },
        { nombre: "MACIAS ANDRADE RAMON", equipo: "LA PRADERA", goles: 1 },
        {
          nombre: "VALENCIA NAZARENO ANDRES",
          equipo: "REAL FORTALEZA",
          goles: 1,
        },
        {
          nombre: "VALENCIA NAZARENO LEONEL",
          equipo: "REAL FORTALEZA",
          goles: 1,
        },
      ],
    },
  ];

  const [torneoSeleccionado, setTorneoSeleccionado] = useState(torneos[0]);
  const [vista, setVista] = useState("posiciones"); // 'posiciones' o 'goleadores'

  return (
    <div className="p-6 bg-gradient-to-b from-blue-900 to-blue-600 min-h-screen text-white">
      <div className="flex justify-center mb-6">
        <img src={logo} alt="Logo" className="h-20" />
      </div>

      <div className="flex justify-center">
        <div className="flex w-full max-w-4xl space-x-4 overflow-x-auto pb-4 scrollbar-hide snap-x snap-mandatory">
          {torneos.map((torneo, index) => (
            <button
              key={index}
              onClick={() => setTorneoSeleccionado(torneo)}
              className={`px-6 py-2 whitespace-nowrap rounded-lg text-sm font-bold transition-all snap-center ${
                torneoSeleccionado.titulo === torneo.titulo
                  ? "bg-white text-blue-900"
                  : "bg-blue-700 hover:bg-blue-500"
              }`}
            >
              {torneo.titulo}
            </button>
          ))}
        </div>
      </div>

      {/* Botones de vista */}
      <div className="flex justify-center gap-4 mt-4">
        <button
          onClick={() => setVista("posiciones")}
          className={`px-4 py-2 rounded-lg font-semibold ${
            vista === "posiciones"
              ? "bg-white text-blue-900"
              : "bg-blue-700 hover:bg-blue-500"
          }`}
        >
          Posiciones
        </button>
        <button
          onClick={() => setVista("goleadores")}
          className={`px-4 py-2 rounded-lg font-semibold ${
            vista === "goleadores"
              ? "bg-white text-blue-900"
              : "bg-blue-700 hover:bg-blue-500"
          }`}
        >
          Goleadores
        </button>
      </div>

      {/* Contenido */}
      <div className="bg-white text-gray-900 p-6 shadow-2xl rounded-2xl max-w-4xl mx-auto mt-6">
        <h2 className="text-3xl font-extrabold mb-6 text-center text-blue-900 uppercase">
          {torneoSeleccionado.titulo}
        </h2>

        {vista === "posiciones" ? (
          <div className="overflow-x-auto">
            <table className="w-full border-collapse text-sm shadow-md">
              <thead>
                <tr className="bg-blue-800 text-white text-center uppercase text-xs">
                  <th className="p-3 sticky left-0 bg-blue-800">Pos</th>
                  <th className="p-3 text-left sticky left-[40px] bg-blue-800">
                    Equipo
                  </th>
                  <th className="p-3 min-w-[50px]">PJ</th>
                  <th className="p-3 min-w-[50px]">PG</th>
                  <th className="p-3 min-w-[50px]">PE</th>
                  <th className="p-3 min-w-[50px]">PP</th>
                  <th className="p-3 min-w-[50px]">GF</th>
                  <th className="p-3 min-w-[50px]">GC</th>
                  <th className="p-3 min-w-[50px]">DG</th>
                  <th className="p-3 min-w-[50px]">PTS</th>
                </tr>
              </thead>
              <tbody>
                {torneoSeleccionado.equipos.map((equipo, idx) => {
                  const esEliminado = equipo.status === "eliminado";

                  return (
                    <tr
                      key={idx}
                      className={`text-center border-b ${
                        idx % 2 === 0 ? "bg-gray-100" : "bg-gray-200"
                      } ${
                        esEliminado ? "bg-red-200 text-red-700 font-bold" : ""
                      }`}
                    >
                      <td className="p-0 font-bold sticky left-0 bg-white w-[40px] h-[40px]">
                        <div className="relative w-full h-full flex items-center justify-center">
                          <div
                            className="absolute top-0 left-0 h-full"
                            style={{
                              width: "10%",
                              backgroundColor: equipo.color || "transparent",
                              borderTopLeftRadius: "6px",
                              borderBottomLeftRadius: "6px",
                            }}
                          ></div>
                          <span className="relative z-10 text-blue-800">
                            {equipo.posicion}
                          </span>
                        </div>
                      </td>
                      <td className="p-3 text-left font-semibold sticky left-[40px] bg-white">
                        {equipo.equipo}
                      </td>
                      {esEliminado ? (
                        <td colSpan="8" className="p-3 text-center">
                          Eliminado
                        </td>
                      ) : (
                        <>
                          <td className="p-3">{equipo.PJ}</td>
                          <td className="p-3">{equipo.PG}</td>
                          <td className="p-3">{equipo.PE}</td>
                          <td className="p-3">{equipo.PP}</td>
                          <td className="p-3">{equipo.GF}</td>
                          <td className="p-3">{equipo.GC}</td>
                          <td className="p-3 font-semibold">{equipo.DG}</td>
                          <td className="p-3 font-bold text-xl text-blue-800">
                            {equipo.PTS}
                          </td>
                        </>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full border-collapse text-sm shadow-md">
              <thead>
                <tr className="bg-blue-800 text-white text-center uppercase text-xs">
                  <th className="p-3">Jugador</th>
                  <th className="p-3">Equipo</th>
                  <th className="p-3">Goles</th>
                </tr>
              </thead>
              <tbody>
                {torneoSeleccionado.goleadores.map((goleador, idx) => (
                  <tr
                    key={idx}
                    className={`text-center border-b ${
                      idx % 2 === 0 ? "bg-gray-100" : "bg-gray-200"
                    }`}
                  >
                    <td className="p-3 font-semibold">{goleador.nombre}</td>
                    <td className="p-3">{goleador.equipo}</td>
                    <td className="p-3 font-bold text-blue-800">
                      {goleador.goles}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
